'use es6';

import * as DSAssetFamilies from '../../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { fromJS } from 'immutable';
import FilterDefinitionCompanies from './fieldDefinitions/FilterDefinitionCompanies';
import FilterDefinitionContacts from './fieldDefinitions/FilterDefinitionContacts';
import FilterDefinitionDeals from './fieldDefinitions/FilterDefinitionDeals';
import FilterDefinitionEngagements from './fieldDefinitions/FilterDefinitionEngagements';
import FilterDefinitionHierarchicalTeams from '../../filterQueryFormat/sharedFieldDefinitions/FilterDefinitionHierarchicalTeams';
import FilterDefinitionLineItems from './fieldDefinitions/FilterDefinitionLineItems';
const fieldDefinitions = fromJS({
  [DSAssetFamilies.COMPANY_PROPERTY]: FilterDefinitionCompanies,
  [DSAssetFamilies.CONTACT_PROPERTY]: FilterDefinitionContacts,
  [DSAssetFamilies.DEAL_PROPERTY]: FilterDefinitionDeals,
  [DSAssetFamilies.LINE_ITEM_PROPERTY]: FilterDefinitionLineItems,
  [DSAssetFamilies.ENGAGEMENT_PROPERTY]: FilterDefinitionEngagements
});
export const getFieldDefinitions = () => {
  const assetFamilies = [DSAssetFamilies.COMPANY_PROPERTY, DSAssetFamilies.CONTACT_PROPERTY, DSAssetFamilies.DEAL_PROPERTY];
  return fieldDefinitions.withMutations(definitions => {
    assetFamilies.forEach(objectType => {
      return definitions.mergeIn([objectType], FilterDefinitionHierarchicalTeams);
    });
  });
};